import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-ashim-matthan',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ashim-matthan.html',
  styleUrl: './ashim-matthan.css',
})
export class AshimMatthan {

}
